<template>
	<div class="tabWrapper userTabWrapper">
		<div class="filtersWrap">

			<field
					v-if="filter_company_list"
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'company')"
					:multiValue="company"
					:items="filter_company_list"
					label="Company"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach
					is-clearable
			></field>

			<field
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'location')"
					:multiValue="location"
					:items="filter_location_list"
					label="Location"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach
			></field>

			<field
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'office')"
					:multiValue="office"
					:items="filter_office_list"
					label="Office"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach
			></field>

			<field
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'department')"
					:multiValue="department"
					:items="filter_department_list"
					label="Department"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach

			></field>

			<field
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'position')"
					:multiValue="position"
					:items="filter_position_list"
					label="Position"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach
			></field>

			<field
					v-if="filter_name_list"
					margin="0"
					@updateMultiSelect="onAutocomplete($event, 'name')"
					:multiValue="name"
					:items="filter_name_list"
					label="Name"
					is-multiple
					is-btn-all
					:isClearable="true"
					is-attach
			></field>

			<custom-btn
					text="Refresh filter"
					@updateEvent="onRefresh"
					custom-class="apply refresh"
					is-all-elements
					is-extended
					margin='0'
					:icon-attrs="{width: 20, height: 20, iconId: 'refresh'}"
			></custom-btn>

		</div>
		<div class="userListWrapper">
			<div class="userListWrap">
				<user-list-item
						v-for="(item, index) in listItems"
						:key="uniqKey(index)"
						:item="item"
						:has-link="getPermissionAccountUsers"
						@updatePhotoZoom="onPhotoZoom"
				></user-list-item>
			</div>
		</div>

		<pagination
				v-if="listItems && listItems.length && isPagination"
				:length="listItems.length"
				:pageCount="pageCount"
				:items-per-page="limit"
				:page="page"
				:isRefresh="isRefresh"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				is-flag-one
				@updatePreloader="onPreloader"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>

		<preloader v-if="isPreloader" :preload="isPreloader"></preloader>

		<preview-doc
				v-if="linkPreviewDoc"
				@clear-link="clearLinkPreviewDoc"
				:link-doc="linkPreviewDoc"
				:file-name="fileName"
		></preview-doc>
	</div>
</template>

<script>
import UserListItem from "@/shared/UserListItem/UserListItem.vue";
import getUniqId from "@/helper/getUniqId";
import Pagination from "@/shared/Pagination/Pagination.vue";
import Preloader from "@/shared/Preload/Preload.vue";
import { mapActions, mapGetters } from "vuex";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "AccountTabUsers",
	components: { PreviewDoc, Preloader, Pagination,
		UserListItem
	},
	computed: {
		...mapGetters([
			'accountUsers_limit',
			'accountUsers_order',
			'accountUsers_rows',
			'accountUsers_sort',
			'accountUsers_total',
			'accountUsers_filter',
			'accountUsers_filter_department',
			'accountUsers_filter_location',
			'accountUsers_filter_name',
			'accountUsers_filter_company',
			'accountUsers_filter_office',
			'accountUsers_filter_position',
			'permissions',
		]),
		getPermissionAccountUsers() {
			return this.permissions[PERMISSIONS.ACCOUNT_USERS];
		},
	},
	data: () => ({
		isPreloader: false,

		flag: 'AccountTabSalaryHistory',
		isPagination: true,
		pages: [ 6, 12, 36, 48, 72, 98, "All" ],
		isRefresh: null,
		isRefreshPage: '',

		listItems: [],

		filter_department_list: [],
		filter_location_list: [],
		filter_name_list: [],
		filter_office_list: [],
		filter_position_list: [],
		filter_company_list: [],

		filter_location: [],
		filter_office: [],
		filter_department: [],
		filter_position: [],
		filter_name: [],
		filter_company: [],

		location: null,
		office: null,
		department: null,
		position: null,
		name: null,
		company: null,

		order: null,
		sort: null,
		limit: 12,
		total: null,
		page: null,
		pageCount: null,

		series: null,
		linkPreviewDoc: null,
		fileName: null,

	}),
	methods: {
		...mapActions([
			'getAccountUsersList',
			'updateAccountUsersList',
			'filtersAccountUsersList',
		]),
		onPreloader() {
			this.isPreloader = true;
		},
		onPagination(value) {
			this.page = value;
			this.updateFilterList();
		},

		onCountPagination(value) {
			this.page = 1;
			this.limit = value === "All" ? 99999 : value;
			this.isPreloader = false;
			this.page = 1;
			this.updateFilterList();
		},

		onAutocomplete(args, key) {
			const { value } = args;

			// Проверка: value может быть массивом или объектом
			const values = Array.isArray(value) ? value : Object.values(value);

			const ids = values.map(item => {
				if (item && typeof item === 'object' && 'id' in item) {
					return item.id;
				}
				// если item — это число или строка напрямую
				if (typeof item === 'number' || typeof item === 'string') {
					return item;
				}
				return undefined;
			}).filter(v => v !== undefined);

			this['filter_' + key] = ids;
			this[key] = values;

			this.updateFilterList();
		},

		async updateFilterList() {
			this.listItems = null;
			const { filter_location, filter_office, filter_department, filter_position, filter_name, filter_company, order, sort, limit, page } = this.$data;
			const values = { filter_location, filter_office, filter_department, filter_position, filter_name, filter_company, order, sort, limit, page };
			localStorage.setItem('updateAccountUsersFilter', JSON.stringify(values));

			await this.filtersAccountUsersList(values);
			await this.updateAccountUsersList(values);

			this.updatePaginationPageCount();
		},
		uniqKey(id) {
			return getUniqId() + id;
		},

		updatePaginationPageCount() {
			const { total, limit } = this.$data;

			this.pageCount = Math.ceil(total / limit);
		},

		onPhotoZoom(args) {
			const { photo } = args;
			this.linkPreviewDoc = photo;
			this.fileName = photo.split('/').pop();
		},

		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},

		async onRefresh() {
			this.filter_location = [];
			this.filter_office = [];
			this.filter_department = [];
			this.filter_position = [];
			this.filter_name = [];
			this.filter_company = [];

			this.location = [];
			this.office = [];
			this.department = [];
			this.position = [];
			this.name = [];
			this.company = [];

			this.order = "filter_name";
			this.sort = "desc";
			this.limit = 12;
			this.page = 1;
			const { filter_location, filter_office, filter_department, filter_position, filter_name, filter_company, order, sort, limit, page } = this.$data;
			const values = { filter_location, filter_office, filter_department, filter_position, filter_name, filter_company, order, sort, limit, page };

			localStorage.removeItem('updateAccountUsersFilter');

			await this.filtersAccountUsersList();
			await this.updateAccountUsersList(values);
		},
	},
	async mounted() {
		await this.filtersAccountUsersList();
		const rawFilter = localStorage.getItem('updateAccountUsersFilter');
		const saveFilter = rawFilter ? JSON.parse(rawFilter) : null;
		if (saveFilter && this.$route.hash === '#tabUsers') {
			this.filter_location = saveFilter.filter_location;
			this.filter_office = saveFilter.filter_office;
			this.filter_department = saveFilter.filter_department;
			this.filter_position = saveFilter.filter_position;
			this.filter_name = saveFilter.filter_name;
			this.filter_company = saveFilter.filter_company;

			this.location = saveFilter.filter_location;
			this.office = saveFilter.filter_office;
			this.department = saveFilter.filter_department;
			this.position = saveFilter.filter_position;
			this.name = saveFilter.filter_name;
			this.company = saveFilter.filter_company;

			this.order = saveFilter.order;
			this.sort = saveFilter.sort;
			this.limit = saveFilter.limit;
			this.page = saveFilter.page;
			await this.updateAccountUsersList(saveFilter);

		} else {
			localStorage.removeItem('updateAccountUsersFilter');
			this.filter_location = [];
			this.filter_office = [];
			this.filter_department = [];
			this.filter_position = [];
			this.filter_name = [];
			this.filter_company = [];

			this.location = [];
			this.office = [];
			this.department = [];
			this.position = [];
			this.name = [];
			this.company = [];

			await this.updateAccountUsersList({ limit: this.limit });

		}
		// await this.updateAccountUsersList({ limit: this.limit });

		this.listItems = this.accountUsers_rows;
		this.filter_department_list = this.accountUsers_filter_department;
		this.filter_location_list = this.accountUsers_filter_location;
		this.filter_name_list = this.accountUsers_filter_name;
		this.filter_company_list = this.accountUsers_filter_company;
		this.filter_office_list = this.accountUsers_filter_office;
		this.filter_position_list = this.accountUsers_filter_position;

		this.order = this.accountUsers_order;
		this.sort = this.accountUsers_sort;
		this.limit = this.accountUsers_limit;
		this.total = this.accountUsers_total;

		this.updatePaginationPageCount();
	},

	watch: {
		accountUsers_rows(val, oldVal) {
			if (val !== oldVal) {
				this.listItems = val;
			}
		},

		accountUsers_total(val, oldVal) {
			if (val !== oldVal) {
				this.total = val;
			}
		},

		accountUsers_filter_department(val, oldVal) {
			if (val !== oldVal) {
				this.filter_department_list = val;
			}
		},
		accountUsers_filter_location(val, oldVal) {
			if (val !== oldVal) {
				this.filter_location_list = val;
			}
		},
		accountUsers_filter_name(val, oldVal) {
			if (val !== oldVal) {
				this.filter_name_list = val;
			}
		},
		accountUsers_filter_company(val, oldVal) {
			if (val !== oldVal) {
				this.filter_company_list = val;
			}
		},
		accountUsers_filter_office(val, oldVal) {
			if (val !== oldVal) {
				this.filter_office_list = val;
			}
		},
		accountUsers_filter_position(val, oldVal) {
			if (val !== oldVal) {
				this.filter_position_list = val;
			}
		},

	},
};
</script>

<style lang="scss">
.filtersWrap {
	.refresh {
		height: 100% !important;
		@media screen and (max-width: 1300px) {
			height: 48px !important;
		}
		span {
			display: none;
			@media screen and (max-width: 1300px) {
				display: block;
			}
		}
	}
}
</style>
<style scoped lang="scss">
@import "AccountTabUsers";
</style>
